export default "__VITE_ASSET__YhwKTHdS__"